import Vue from 'vue'
import Vuex from 'vuex'

import meetings from './modules/meetings'
import locale from './modules/locale'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    locale,
    meetings
  }
})
